/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useAppData } from '@/hooks/useAppData';
import { sessionStorage } from '@/utils/sessionStorage';
import { useLegacyRouter } from '@/hooks/useLegacyRouter';
import { use, useState } from 'react';
import { setCookie } from '@/utils/cookie';
import { getDecodedCookiesSync } from '@/utils/cookie';
import { useFeatureFlag } from '@/features/globalConfig';
import { SearchBoxContext } from '@/components/SearchBoxContext';
import { useSignInFlowType } from '@/components/SignInFlowTypeContext';
import { isServer } from '@/utils/isServer';

export function useShouldShowSignInAlert() {
  const rawPopupShowCount = useFeatureFlag('POPUP_PAGENUMBER_SHOW_COUNT');
  const popupShowCount = rawPopupShowCount ? parseInt(rawPopupShowCount, 10) : 0;
  const { searchBoxOpen } = use(SearchBoxContext);
  const { pageCountRef } = useSignInFlowType();

  const { appData } = useAppData();
  const { userAuthenticated } = appData;
  const router = useLegacyRouter();

  const isClient = typeof document !== 'undefined';

  const alertCookie = isClient ? getDecodedCookiesSync(['alert_timer']) : null;
  const cookie = alertCookie?.get('alert_timer');
  const [show, setShow] = useState(() => {
    if (isServer) {
      return false;
    }
    if (
      (sessionStorage.getItem('signInPopupShown') !== 'true' ||
        sessionStorage.getItem('signInPopupDisabled') !== 'true') &&
      cookie == undefined
    ) {
      return true;
    }
  });

  const hideForSession = () => {
    sessionStorage.setItem('signInPopupShown', 'true');
    const date = new Date();
    void setCookie('alert_timer', 'expires in 10 minutes', {
      expires: new Date(date.setTime(date.getTime() + 10 * 60 * 1000)),
    });
    setShow(false);
  };

  const isModalEligible =
    pageCountRef.current >= popupShowCount &&
    sessionStorage.getItem('DropDownRendered') !== 'true' &&
    sessionStorage.getItem('signInModalOpened') !== 'true';

  return {
    hideForSession,
    shouldShowAlert:
      !userAuthenticated &&
      show &&
      router.route !== '/cart' &&
      router.route !== '/checkout' &&
      isModalEligible &&
      !searchBoxOpen,
  };
}
